module.exports = __webpack_public_path__ + "img/selo-ecotrace.b6551c73.svg";